import { zodResolver } from "@hookform/resolvers/zod";
import type { Resolver } from "react-hook-form";
import { z } from "zod";
import { UI_TEXT_GENERAL_INFOS } from "../constants";
import type { IGeneralInfosForm } from "../types";

export type GeneralInfosFormContext = {
	isTrailerOrSemiTrailer?: boolean;
};

const generalInfosBaseSchema = z.object({
	odometer: z.string().transform((val) => val.trim()),
	checklistType: z
		.string({
			error: UI_TEXT_GENERAL_INFOS.requiredField,
		})
		.refine((val) => val.length > 0, {
			message: UI_TEXT_GENERAL_INFOS.requiredField,
		}),
	fuelLevel: z
		.number({
			error: UI_TEXT_GENERAL_INFOS.requiredField,
		})
		.min(0, { message: "O valor mínimo é 0" })
		.max(100, { message: "O valor máximo é 100" }),
});

function createGeneralInfosSchema(context: GeneralInfosFormContext) {
	return generalInfosBaseSchema.superRefine((data, ctx) => {
		const isTrailerOrSemiTrailer = context.isTrailerOrSemiTrailer ?? false;

		if (!isTrailerOrSemiTrailer && data.odometer.length === 0) {
			ctx.addIssue({
				code: "custom",
				message: UI_TEXT_GENERAL_INFOS.requiredField,
				path: ["odometer"],
			});
		}
	});
}

export const general_infos_schema = generalInfosBaseSchema;

export const generalInfosResolver: Resolver<
	IGeneralInfosForm,
	GeneralInfosFormContext
> = (values, context, options) =>
	zodResolver(createGeneralInfosSchema(context ?? {}))(
		values,
		context,
		options
	);
